import styled from 'styled-components'

export const InputRadioWrapper = styled.div``

export const InputRadioGrupo = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 8px;
  width: 220px;
  position: relative;
`

export const Erro = styled.p`
  position: absolute;
  color: ${({ theme }) => theme.inputBorderError} !important;
  font-size: 12px;
  bottom: -25px;
  margin: 0;
`

export const RightSection = styled.div`
  color: ${({ theme }) => theme.cor9}!important;
  margin-right: 15px;
`
